import React, { Component } from 'react';
import { Col } from '../../base/BootstrapComponents/BootstrapComponents';
import FieldDTO from './FieldDTO';

class FieldDTOWithCol extends Component {
  render() {
    const addProps = {};
    if (this.props.columns) {
      addProps.columns = this.props.columns;
    }
    return (
      <Col {...addProps}>
        <FieldDTO
          {...this.props}
        />
      </Col>
    );
  }
}
export default FieldDTOWithCol;
